import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import axios from "./api/http"
import api from "./api/api"
import ElementUI from "element-ui"
import "./assets/css/element-variables.scss"
import "./assets/css/globle.scss"

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.$bizSys = "2" // 系统编码 (1总后台；2门店)
Vue.prototype.getTodayDate = function () {
  let date = new Date(),
    year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate()

  if (month < 10) {
    month = "0" + month
  }
  if (day < 10) {
    day = "0" + day
  }
  return `${year}-${month}-${day}`
}

Vue.use(ElementUI)

Vue.component("back", () => import("./components/back.vue"))

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app")
